import React from 'react';
import propTypes from './propTypes';

const EquipmentHourlyWork = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21 14.8746V19.5C21 20.3286 20.3284 21 19.5 21C18.6716 21 18 20.3286 18 19.5V18H16V21L14 23V18H12V21L10 23V18H8V21L6 23V18H4V19.5C4 20.3286 3.32837 21 2.5 21C1.67163 21 1 20.3286 1 19.5V14.5C1 13.6714 1.67163 13 2.5 13C3.32837 13 4 13.6714 4 14.5V16H6L7 12L5 3H7L7.70095 6.15428C7.56938 6.74853 7.5 7.36616 7.5 8C7.5 10.3419 8.44711 12.4626 9.9792 14H8.5L8 16H13.1209C14.02 16.3236 14.9894 16.5 16 16.5C17.8689 16.5 19.5969 15.8969 21 14.8746Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M23 8C23 11.866 19.866 15 16 15C12.134 15 9 11.866 9 8C9 4.13401 12.134 1 16 1C19.866 1 23 4.13401 23 8ZM21 8C21 10.7614 18.7614 13 16 13C13.2386 13 11 10.7614 11 8C11 5.23858 13.2386 3 16 3C18.7614 3 21 5.23858 21 8ZM16.4945 4.00492L14.9945 4.00488L14.9944 9.0098L18.6191 11.1462L19.3808 9.85399L16.4944 8.15275L16.4945 4.00492Z" fill="currentColor" />
  </svg>
);

EquipmentHourlyWork.propTypes = propTypes;

export default EquipmentHourlyWork;
